import React, { useState, useEffect } from 'react';
import Chip from "patient-ping-remedy/packages/chip";
import DropdownList from "patient-ping-remedy/packages/dropdown-list";
import Checkbox from "patient-ping-remedy/packages/checkbox";
import {
  ChipWrapper,
  StyledLabelFormFieldTypography
} from "@/components/pages/settings/event_consumers/DropdownMultiSearchSelect.styles";
import {Value} from "patient-ping-remedy/packages/dropdown-list/lib/DropdownList";

export type IdNameType = {
  id?: string;
  name: string;
};

interface MultiSelectFilterProps {
    label: string;
    values: IdNameType[];
    onChange: (values: IdNameType[]) => void;
    handleSearch: (search: string) => Promise<Value[]>;
    isWithinModal?: boolean
}

const DropdownMultiSearchSelect = (props: MultiSelectFilterProps) => {
  const [selectedOptions, setSelectedOptions] = useState<Value[]>(
    props.values.map((val) => ({ value: val.id ?? val.name, label: val.name }))
  );
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    if (selectedOptions.length === props.values.length) return;
    props.onChange(selectedOptions.map((item) => ({id: item.value, name: item.label})));
  }, [selectedOptions]);

  const renderSelectedOptions = () => {
    const selected = selectedOptions.length;

    if (selected > 6 && !showAll) {
      return <ChipWrapper>
        <Chip onClick={() => setSelectedOptions([])}>{selected} options selected</Chip>
      </ChipWrapper>;
    }

    return selectedOptions.map((option, index) => (
      <ChipWrapper key={index}>
        <Chip
          onClick={() =>
            setSelectedOptions((prev) => prev.filter((o) => o.label !== option.label))
          }
        >
          {option.label}
        </Chip>
      </ChipWrapper>
    ));
  };

  return (
    <>
      <StyledLabelFormFieldTypography>{props.label}</StyledLabelFormFieldTypography>
      {selectedOptions.length > 0 && renderSelectedOptions()}

      {selectedOptions.length > 6 && (
        <Checkbox
          value={showAll}
          onChange={setShowAll}
          label={`Show all selected ${props.label.toLowerCase()}`}
        />
      )}

      <DropdownList
        id={`dropdown-${props.label.toLowerCase()}`}
        isWithinModal={props.isWithinModal}
        value={{ label: '', value: '' }}
        noOptionsMessage={() => 'Search for options'}
        isClearable={false}
        handleChange={(value: Value | null) => {
          if (value) {
            setSelectedOptions((prev) => {
              const alreadyExists = prev.some((item) => item.value === value.value);
              return alreadyExists ? prev : [...prev, value];
            });
          }
        }}
        handleSearch={props.handleSearch}
      />
    </>
  );
};

export default DropdownMultiSearchSelect;
